export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const uniqueIdSelector = (state) => state.getIn(['authorization', 'uniqueId'])
export const getActiveModule = (state) => state.getIn(['ui', 'moduleMenu', 'active'])
export const hasRightsLoaded = (state, module) =>
    state.getIn(['authorization', 'accessRights', module, 'isCustomLoaded'], false)
